import { createContext, useContext } from 'react';

export interface NewMessagesBoundaryValue {
  count: number;
  isActive: boolean;
  isDismissing: boolean;
  boundaryKey: string | null;
  jumpPillDirection: 'up' | 'down' | null;
  registerDivider: (el: HTMLElement | null) => void;
  markUserIntent: () => void;
  onThreadScroll: () => void;
  jumpToDivider: () => void;
}

const EMPTY_VALUE: NewMessagesBoundaryValue = {
  count: 0,
  isActive: false,
  isDismissing: false,
  boundaryKey: null,
  jumpPillDirection: null,
  registerDivider: () => undefined,
  markUserIntent: () => undefined,
  onThreadScroll: () => undefined,
  jumpToDivider: () => undefined,
};

export const NewMessagesBoundaryContext = createContext<NewMessagesBoundaryValue>(EMPTY_VALUE);

export function useNewMessagesBoundary(): NewMessagesBoundaryValue {
  return useContext(NewMessagesBoundaryContext);
}
